/**
 * @flow
 * @relayHash 7eeca5f9a517665c54268d03b3ed6eee
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentsForReviewCSVQueryVariables = {|
  justMine?: ?boolean,
  includePending?: ?boolean,
  categories?: ?$ReadOnlyArray<?number>,
  daysUntilExpiration?: ?number,
|};
export type DocumentsForReviewCSVQueryResponse = {|
  +documentsToReviewCsv: ?{|
    +taskId: ?string
  |}
|};
export type DocumentsForReviewCSVQuery = {|
  variables: DocumentsForReviewCSVQueryVariables,
  response: DocumentsForReviewCSVQueryResponse,
|};
*/


/*
query DocumentsForReviewCSVQuery(
  $justMine: Boolean
  $includePending: Boolean
  $categories: [Int]
  $daysUntilExpiration: Int
) {
  documentsToReviewCsv(justMine: $justMine, includePending: $includePending, categories: $categories, daysUntilExpiration: $daysUntilExpiration) {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "justMine",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includePending",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "categories",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "daysUntilExpiration",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "documentsToReviewCsv",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categories",
        "variableName": "categories",
        "type": "[Int]"
      },
      {
        "kind": "Variable",
        "name": "daysUntilExpiration",
        "variableName": "daysUntilExpiration",
        "type": "Int"
      },
      {
        "kind": "Variable",
        "name": "includePending",
        "variableName": "includePending",
        "type": "Boolean"
      },
      {
        "kind": "Variable",
        "name": "justMine",
        "variableName": "justMine",
        "type": "Boolean"
      }
    ],
    "concreteType": "CSVTaskResult",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DocumentsForReviewCSVQuery",
  "id": "984992327d877cc9a06c76cb0a64c23b",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DocumentsForReviewCSVQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "DocumentsForReviewCSVQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query DocumentsForReviewCSVQuery(\n  $justMine: Boolean\n  $includePending: Boolean\n  $categories: [Int]\n  $daysUntilExpiration: Int\n) {\n  documentsToReviewCsv(justMine: $justMine, includePending: $includePending, categories: $categories, daysUntilExpiration: $daysUntilExpiration) {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = '8a354b17b0825fedb808917903011d3c';
module.exports = node;
